export const NAME = "offerRequests"
export const FIREBASE_PATH = "offerRequests"
export const FIREBASE_PATH_STILAUS = "stilaus"
